import type { PaletteMode } from "@mui/material";

/** Page titles and navigation labels */
export const brandTextMain = (mode: PaletteMode) =>
  mode === "dark" ? "rgb(160, 185, 220)" : "#4f74ab";

/** Accent for primary actions, header, FAB — teal (pairs with steel blue, no orange tones) */
export const complementaryPrimary = {
  light: {
    main: "#2a7d7d",
    dark: "#1f5c5c",
    light: "#5cb3b3",
    contrastText: "#ffffff",
  },
  dark: {
    main: "#4db6b3",
    dark: "#3a9e9a",
    light: "#7fd4d0",
    contrastText: "#ffffff",
  },
} as const;
